import axios from "axios";
import {message} from "antd";
import {
  getCurrentUser,
  logout,
  saveClipCount,
  saveCreditCount,
  saveNewTaxCasesCount,
  saveNotificatiosCount,
} from "./authService";
import log, {setLogContext} from "./logService";
import _t from "../lang/translate";
import showLoginModal from "../components/modal/showLoginModal";
import {ProductType} from "../types/appTypes";

let isRequestingLogin = false;
let requestsToRefresh: any[] = [];

export function setJwt(jwt: string | null) {
  if (jwt !== null) axios.defaults.headers.common.Authorization = `Bearer ${jwt}`;
}
const numberRegex = /^[0-9]+$/;
const CASE_ROUTE_CONTEXTS = [
  { prefix: "/tax-legal", context: "taxLegal" as ProductType },
  { prefix: "/tax", context: "tax" as ProductType },
  { prefix: "/leasing-dmf", context: "leasing" as ProductType },
  { prefix: "/bilimport", context: "import" as ProductType },
];
function getCurrentCaseContext(): string | null {
  const pathname = window.location.pathname;
  const parts = pathname.split("/").filter(Boolean);
  const id = parts[parts.length - 1];
  const match = CASE_ROUTE_CONTEXTS.find(({ prefix }) => pathname.startsWith(prefix));
  if (match && id && numberRegex.test(id)) {
    return `${match.context}:${id}`;
  }
  return null
}

axios.interceptors.request.use((config) => {
  const caseContext = getCurrentCaseContext();
  if (caseContext) {
    config.headers['X-Case-Context'] = caseContext;
  } else {
    config.headers['X-Case-Context'] = 'null';
  }
  return config;
});

axios.interceptors.response.use(
  (r) => {
    saveNotificatiosCount(r.headers["x-unreadnotifications"], r.headers["x-unreadposts"]);
    saveClipCount(r.headers["x-clipamount"]);
    saveCreditCount(r.headers["x-creditsleft"]);
    saveNewTaxCasesCount(r.headers["x-newtaxcases"]);
    return r;
  },
  async (error) => {
    const { response, config } = error;
    const status = response && response.status;
    const user = getCurrentUser();
    if (status === 401 && user) {
      if (!isRequestingLogin) {
        isRequestingLogin = true;
        showLoginModal()
          .then((token) => {
            requestsToRefresh.forEach((cb) => cb(token));
          })
          .catch(() => {
            requestsToRefresh.forEach((cb) => cb(null));
            logout();
            window.location.href = "/";
          })
          .finally(() => {
            // Clear queue of failed requests
            requestsToRefresh = [];
            isRequestingLogin = false;
            return null;
          });
      } else {
        if (config.url.includes("login")) {
          setLogContext({ error_response: response });
          log(error.response);
          return Promise.reject(error);
        }
      }

      return new Promise((resolve, reject) => {
        requestsToRefresh.push((token: string) => {
          if (token) {
            config.headers.Authorization = "Bearer " + token;
            resolve(axios(config));
          }
          reject(error);
        });
      });
    } else if (status <= 400 && status > 500) {
      setLogContext({ error_response: error.response });
      log(error.response);
      message.error(_t("msg.unknown_error"));
      return Promise.reject(error.response);
    } else if (status === 503) {
      setLogContext({ error_response: error.response });
      message.error(_t("msg.maintenance"));
      //window.open("/maintenance.html", "_self");
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

const items = {
  get: axios.get,
  post: axios.post,
  delete: axios.delete,
  put: axios.put,
  patch: axios.patch,
  headers: axios.defaults.headers,
};

export default items;
